import styled from 'styled-components'

// Icons
import { ReactComponent as DotsIcon } from '@sketch/icons/dots-3-horizontal-24'
import { ReactComponent as StackPlus } from '@sketch/icons/square-stack-plus-circle-24'

// Components
import { Button, WorkspaceLogo } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'

export const HeaderButton = styled(Button).attrs({
  size: '40',
  variant: 'secondary',
})``

export const SharingButton = styled(HeaderButton)`
  padding: 7px 12px 7px 7px; /* stylelint-disable-line scales/space */
  margin-right: 16px;

  ${WorkspaceLogo}, ${WorkspaceLogo.Icon} {
    margin-right: 8px;
  }

  ${WorkspaceLogo.Icon} {
    border: 1px solid ${({ theme }) => theme.colors.border.A};
    color: ${({ theme }) => theme.colors.foreground.secondary.C};
  }
`

export const CreateCollectionButton = styled(HeaderButton)`
  margin-right: 16px;
`

export const Dots = styled(DotsIcon)`
  width: 24px;
  height: 24px;
`

export const ButtonWrapper = styled.div`
  display: flex;
`

export const TextWrapper = styled.div`
  line-height: 1;
  margin-left: 12px;
`

export const CollectionIcon = styled(StackPlus)`
  width: 24px;
  height: 24px;
  margin-right: 8px;

  ${breakpoint('base', 'sm')`
    margin-right: 0px;
  `}
`
